// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class SiteAccountSearchAccountsDefaultResponse {
    static getAttributeTypeMap() {
        return SiteAccountSearchAccountsDefaultResponse.attributeTypeMap;
    }
}
SiteAccountSearchAccountsDefaultResponse.discriminator = undefined;
SiteAccountSearchAccountsDefaultResponse.additionalProperties = false;
SiteAccountSearchAccountsDefaultResponse.attributeTypeMap = [
    {
        "name": "success",
        "baseName": "success",
        "type": "boolean"
    },
    {
        "name": "messages",
        "baseName": "messages",
        "type": ""
    },
    {
        "name": "data",
        "baseName": "data",
        "type": ""
    },
];
//# sourceMappingURL=siteAccountSearchAccountsDefaultResponse.js.map